import { type Colors } from '@factorialco/deprecated-design-system'

import { ContractSchedule } from 'modules/contracts/lib/contractSchedule'

export const getMilestoneColor = (contractVersionSchedule: string): Colors => {
  switch (contractVersionSchedule) {
    case ContractSchedule.upcoming:
      return 'champagne1000'
    case ContractSchedule.ongoing:
      return 'viridian600'
    default:
      return 'grey600'
  }
}
